import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import EmailIcon from "@material-ui/icons/Email";
import { withRouter } from "react-router-dom";
import { useStyles } from "./Count.css";

const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#2ad729",
    color: "black",
  },
}))(Badge);

class MessageCount extends Component {
  handleMessage = () => {
    this.props.history.push("/mymessage");
  };

  render() {
    const { classes } = this.props;
    return (
      <div onClick={this.handleMessage} className={classes.cartStyle}>
        <IconButton disableRipple>
          <StyledBadge max={10} badgeContent={this.props.badgeContent}>
            <EmailIcon style={{ color: "#eee" }} />
          </StyledBadge>
        </IconButton>
        <label>{this.props.label}</label>
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(MessageCount));
